export default "__VITE_ASSET__DgINrsfk__"